var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcActionShareembed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_action_shareembed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8,22 C7.864,22 7.727,21.973 7.594,21.914 C7.09,21.689 6.862,21.099 7.087,20.594 L15.087,2.594 C15.313,2.09 15.904,1.861 16.407,2.087 C16.912,2.311 17.138,2.902 16.915,3.407 L8.915,21.407 C8.748,21.778 8.382,22 8,22 Z M7.857,15.515 C8.141,15.041 7.988,14.427 7.514,14.143 L3.944,12 L7.515,9.857 C7.989,9.573 8.142,8.959 7.858,8.485 C7.573,8.011 6.959,7.859 6.485,8.143 L1.485,11.143 C1.184,11.323 1,11.649 1,12 C1,12.351 1.184,12.677 1.485,12.857 L6.485,15.857 C6.646,15.954 6.824,16 6.999,16 C7.339,16 7.67,15.827 7.857,15.515 Z M17.515,15.857 L22.515,12.857 C22.815,12.677 23,12.351 23,12 C23,11.649 22.815,11.323 22.515,11.143 L17.515,8.143 C17.04,7.858 16.427,8.013 16.143,8.486 C15.859,8.96 16.012,9.574 16.486,9.858 L20.057,12 L16.486,14.143 C16.012,14.427 15.859,15.041 16.143,15.515 C16.33,15.827 16.661,16 17.001,16 C17.176,16 17.354,15.954 17.515,15.857 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_action_shareembed",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "//-Base",
    fillOpacity: 0,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionShareembed);
export default __webpack_public_path__ + "static/media/ic_action_shareembed.21a6ef2ae7fa7b558797b913abbb142e.svg";
export { ForwardRef as ReactComponent };